export const generateBreadcrumbs = (FullURL: string) => {
    const siteURL = process.env.NEXT_PUBLIC_BASE_URL || ''; 

    const pathArray = FullURL.split("/").filter(Boolean);

    const breadcrumbs = [
        {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: siteURL + "/",
        },
        ...pathArray.map((segment, index) => ({
            "@type": "ListItem",
            position: index + 2,
            name: segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' '),
            item: `${siteURL}/${pathArray.slice(0, index + 1).join("/")}`,
        })),
    ];

    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs,
    });
};
